"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usersList = exports.usersData = exports.roleList = exports.mineSites = void 0;
const usersList = exports.usersList = [{
  objectId: '50742438-178d-48fa-90ec-541a7ecf0c8d',
  displayName: 'Amanda Young',
  email: 'amanda.young@diagonalenergy.com',
  status: 'Removed on: 07-Apr-2020',
  appRoleObjectId: '9d47fe10-903c-4a89-8f4f-432761a4838e',
  lastLogin: '07-Apr-2020 05:42 PM'
}, {
  objectId: 'b0f043f3-2360-4cce-b7d0-36c4debe181e',
  displayName: 'amanda.young40@diagonalenergy.com',
  email: 'amanda.young40@diagonalenergy.com',
  status: 'Active From: 09-Jan-2020',
  appRoleObjectId: 'af4d6883-767c-4d7b-9c40-f91f674099d4',
  lastLogin: null
}, {
  objectId: 'bfcbc401-770f-4edb-84d9-4644e3826f28',
  displayName: 'Christopher Haig',
  email: 'Christopher.Haig@mail.weir',
  status: 'Removed on: 07-Jan-2020',
  appRoleObjectId: 'e31f3a4e-681f-49ff-9376-309fd69981cc',
  lastLogin: '14-Apr-2020 06:54 AM'
}, {
  objectId: '764d5b66-0966-454f-b3b1-a21ce969dad4',
  displayName: 'Mark Janos',
  email: 'mark.janos@mail.weir',
  status: 'Active From: 24-Oct-2019',
  appRoleObjectId: 'c3b977cb-ab2d-4673-9eba-a66afcfcf206',
  lastLogin: '17-Apr-2020 07:27 AM'
}];
const roleList = exports.roleList = [{
  appRoleObjectId: '3d47fe10-903c-4a89-8f4f-432761a4838e',
  appRoleDisplayName: 'Viewer',
  appRoleDescription: 'Viewers',
  label: 'Viewer',
  name: 'Viewer',
  value: '3d47fe10-903c-4a89-8f4f-432761a4838e'
}, {
  appRoleObjectId: '4c8a5d4a-a21f-4caf-941a-74033b099ec8',
  appRoleDisplayName: 'Data Manager',
  appRoleDescription: 'Data Manager of the Dummy Test Application',
  label: 'Data Manager',
  name: 'Data Manager',
  value: '4c8a5d4a-a21f-4caf-941a-74033b099ec8'
}, {
  appRoleObjectId: 'af4d6883-767c-4d7b-9c40-f91e674099d4',
  appRoleDisplayName: 'Administrator',
  appRoleDescription: 'Administrator of the Dummy Test Application',
  label: 'Administrator',
  value: 'af4d6883-767c-4d7b-9c40-f91e674099d4',
  name: 'Administrator'
}, {
  appRoleObjectId: 'c3b972cb-ab2d-4673-9eba-a66afcfcf206',
  label: 'Access As user',
  value: 'c3b972cb-ab2d-4673-9eba-a66afcfcf206',
  name: 'Access As user',
  appRoleDisplayName: 'Access As user',
  appRoleDescription: 'Access As user'
}, {
  appRoleObjectId: 'd31f3a4e-681f-49ff-9376-309fd69981cc',
  name: 'Application Manager',
  appRoleDisplayName: 'Application Manager',
  label: 'Application Manager',
  value: 'd31f3a4e-681f-49ff-9376-309fd69981cc',
  appRoleDescription: 'Grants users access to Applications in the context of a Business Entity'
}];
const usersData = exports.usersData = [{
  userDisplayName: 'Amanda Young',
  userEmail: 'amanda.young@diagonalenergy.com',
  userObjectId: '025cab30-ea98-43ae-9a5b-a8c58ac1d02d'
}, {
  userDisplayName: 'Abhinay GS',
  userEmail: 'abhinay.gs@mail.weir',
  userObjectId: '025cab30-ea98-43ae-9a5b-a8c58ac1d01d'
}, {
  userDisplayName: 'Mark Janos',
  userEmail: 'mark.janos@mail.weir',
  userObjectId: '0afd0869-6a58-4db0-8d15-c244db30c88b'
}, {
  userDisplayName: 'Richard Brinks',
  userEmail: 'richard.brinks@diagonalenergy.com',
  userObjectId: '025cab30-ea98-43ae-9a5b-b8c58ac1d02d'
}, {
  userDisplayName: 'Paul Brooks',
  userEmail: 'paul.brooks@diagonalenergy.com',
  userObjectId: '025cab31-ea98-43ae-9a5b-b8c58ac1d02d'
}];
const mineSites = exports.mineSites = [{
  appDisplayName: "Dummy Test Application",
  appRoleDisplayName: "Viewer",
  businessEntityName: "GoldsboroughAggregates",
  businessEntityDescription: "GoldsboroughAggregates",
  userObjectId: "035cab30-ea98-43ae-9a5b-a8c58ac1d01d",
  businessEntityObjectId: "8d61ed7d-f2e1-4feb-9782-11fc2b7ed75b",
  appRoleObjectId: "9c8a5d4a-c21f-4caf-041a-74033b099ec8",
  status: 'Active From: 28-Feb-2021'
}, {
  appDisplayName: "IAM Portal",
  appRoleDisplayName: "Application Manager",
  businessEntityName: "Partner",
  businessEntityDescription: "Partner",
  userObjectId: "525cab30-ea98-43ae-9b5b-a8c58ac1d01d",
  businessEntityObjectId: "4ed9e615-fc4e-4249-8211-68d39ebe90ab",
  appRoleObjectId: "d31f3a4e-681f-49ff-9376-009fd69981cc",
  status: 'Active From: 17-Mar-2022'
}, {
  appDisplayName: "Offline Data Uploader",
  appRoleDisplayName: "User",
  businessEntityName: "GoldsboroughAggregates",
  businessEntityDescription: "GoldsboroughAggregates",
  userObjectId: "125cab30-ea98-43ae-9a5b-a9c58ac1d01d",
  businessEntityObjectId: "9d61ed7d-f2e1-4feb-9082-11fc2b7ed75b",
  appRoleObjectId: "1e0be6dc-21ac-4352-8ac1-2a3ee59a0f51",
  status: 'Active From: 01-Feb-2023'
}];